import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useTrainingPlan(orgId) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPlans = useCallback(async () => {
    if (!orgId) return;
    const { data } = await supabase
      .from('training_plan')
      .select('*')
      .eq('org_id', orgId);
    setPlans(data || []);
    setLoading(false);
  }, [orgId]);

  useEffect(() => {
    if (!orgId) return;
    loadPlans();
  }, [orgId, loadPlans]);

  async function upsertPlan(apprenticeId, unitCode, year) {
    const existing = plans.find(p => p.apprentice_id === apprenticeId && p.unit_code === unitCode);
    if (existing) {
      await supabase.from('training_plan').update({ year }).eq('id', existing.id);
    } else {
      await supabase.from('training_plan').insert({
        apprentice_id: apprenticeId,
        unit_code: unitCode,
        year,
        org_id: orgId,
      });
    }
    await loadPlans();
  }

  function getApprenticePlan(apprenticeId) {
    return plans.filter(p => p.apprentice_id === apprenticeId);
  }

  return { plans, loading, upsertPlan, getApprenticePlan, reload: loadPlans };
}
